import { LocalizationUtility } from './LocalizationUtility';

export class TitleService {
    constructor(private readonly i18n: LocalizationUtility) {
    }

    public detectTitle(attributeKey: string): string | undefined {
        const title = attributeKey.split('.').pop();
        if (typeof title === 'undefined') {
            return undefined;
        }

        if (this.i18n.hasTranslation(title)) {
            return this.i18n.translate(title);
        }

        if (title.substr(0, 8) === 'Freitext') {
            return 'Bemerkung';
        }
        if (/Beschreibung/i.test(title)) {
            return 'Beschreibung';
        }

        if (title.indexOf('_') > -1) {
            return this.detectTitle(title.replace(/_/g, ' '));
        }

        return title;
    }
}
